
























































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat, downloadFile } from "@/utils/index";
import {smsStatsExport} from "@/request/smsStatsData";
import { getOrderOptions } from "@/request/ticketClientRequest";
const roleList = () => import("@/components/roleList/index.vue");
@Component({
  name: "smsStats",
  components: {
    roleList
  }
})

export default class smsStats extends Vue {
  private mounted() {

  }
  @Provide() private queryDimension: any = []; // 查询维度
  @Provide() private dimensionList: any = [1]; // table Head查询维度
  private getUserStatusOptions() {
    this.queryDimension = [
      { value: 0, label: this.$t('formLgy.Date') }, // 日期 DATE
      { value: 1, label: this.$t('formLgy.Name') }, // 员工姓名 USER
      { value: 2, label: this.$t('tableLgy.EmployeeRole') }, // 员工角色 ROLE
      { value: 3, label: this.$t('formLgy.TicketCategory') } // 工单类型 ITEM
    ];
  };
  @Provide() private resultTicketItemData: any = []; // 工单类型列表
  @Provide() private roleOptions: any = []; // 角色列表
  // lee 获取查询参数
  private async getSmsStatsListParam() {
    let res: any = await getOrderOptions({
      token: this.token
    });
    switch (res.status) {
      case "success":
        this.resultTicketItemData = res && res.data ? res.data : []; // 工单类型列表
        break;
      case "code":
        this.$router.push("./login");
        break;
      case "error":
        this.$message.error(res.message);
        break;
    }
  }
  // 查询参数
  @Provide() private searchForm: any = {
    pickDate: "",
    user: "",
    userID:"",
    roleIDs: "",
    itemID: "",
    dimension:[1]
  }; 
  // lee 搜索表单
  @Provide() private searchFormRules: any = {
    pickDate: [
      {
        type: "date",
        required: true,
        message: "pls choose time at least",
        trigger: "change"
      }
    ]
  };
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {},
    shortcuts: [
      {
        text: "Today",
        onClick(picker: any) {
          const start = new Date();
          const _starttime =
            start.getFullYear() +
            "-" +
            (start.getMonth() + 1) +
            "-" +
            start.getDate();
          start.setTime(new Date(_starttime).getTime());
          const end = new Date();
          end.setTime(end.getTime());
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Yesterday",
        onClick(picker: any) {
          const end = new Date();
          const _endtime =
            end.getFullYear() +
            "-" +
            (end.getMonth() + 1) +
            "-" +
            end.getDate();
          end.setTime(new Date(_endtime).getTime());
          const start = new Date();
          start.setTime(new Date(_endtime).getTime() - 24 * 60 * 60 * 1000);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Last 7 days",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }
    ],
    start: "00:00",
    step: "00:10",
    end: "23: 50"
  };
  @Provide() private labelPosition: string = "right";
  @Provide() private pickDate: any = ""; // 时间范围
  @Provide() private resultData: any = [];
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private isExportFormActionDone: boolean = false;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  @Provide() private token: any = "";
  private created() {
    this.token = localStorage.getItem("token");
    this.getUserStatusOptions();
    this.getSmsStatsListParam(); // 获取列表数据
  }
  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    if (this.searchForm.dimension.length > 0 && this.searchForm.pickDate) {
      return true;
    } else if(this.searchForm.dimension.length <= 0) {
      this.$message.error("Please select at least one query dimension!");
      return false;
    } else {
      this.$message.error("pls choose Time at least!");
      return false;
    }
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    this.getSmsStatsList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    this.getSmsStatsList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      this.getSmsStatsList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
      this.getSmsStatsList();
  }
  //  lee 搜索操作
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.pagerCount = 0;
      this.pageIndex = 1;
      this.isSearchFormActionDone = true;
      this.getSmsStatsList();
    }
  }
  //  lee 导出操作
  private async exportFormAction() {
    const { smsStatsExport }: any = await import(
      "@/request/smsStatsData"
    );
    let response = await smsStatsExport(
      this.getSmsStatsListFuc(),
      this
    );
    this.isExportFormActionDone = response ? response.loading : false;
    if (response) {
      if(response.array[3] && response,response.array[3].length>0){
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        downloadFile(blob, response.array[2]);
      }
    }
  }
  // lee 获取列表
  private getSmsStatsListFuc() {
    let _arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      pickDate: this.searchForm.pickDate ? timeFormat(this.searchForm.pickDate[0]) + " - " + timeFormat(this.searchForm.pickDate[1]): null,
      user: this.searchForm.user,
      roleIDs: this.searchForm.roleIDs + "",
      itemID: this.searchForm.itemID + "",
      dimension: this.searchForm.dimension,
      userID: this.searchForm.userID
    };
    console.log(_arg)
    return _arg;
  }
  // 查询
  private async getSmsStatsList() {
    this.resultData = [];
    const { smsStats }: any = await import(
      "@/request/smsStatsData"
    );
    let res = await smsStats(this.getSmsStatsListFuc(), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.smsstatsList == "object"
          ? res.smsstatsList
          : JSON.parse(res.smsstatsList);
      if (_result) {
        this.dimensionList = this.searchForm.dimension;
        this.resultData = _result;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
